<template>
  <ContentCenter class="bg-color-load-blue radial-gradient-loading">
    <template #top>
      <div class="absolute bg-color-load-header-blue w-full md:h-32 h-1/6 top-0 down-stroke-white-2" />
    </template>

    <template #center>
      <div class="flex w-full">
        <div class="md:flex hidden justify-end items-center w-1/2">
          <div>
            <div class="flex justify-end w-full">
              <div class="w-2/3">
                <img :src="getAssetPath('/img/logo-portfolio-white.webp')" :alt="$t('alt.logoLogin')" class="mb-3" />
              </div>
            </div>
            <div class="w-full flex justify-end">
              <div class="w-2/3">
                <h2 class="text-white text-lg" :class="localeStore.currentLocale === 'he' ? 'text-right' : 'text-left'">
                  {{ $t('message.toBegin') }}
                </h2>
              </div>
            </div>
          </div>
        </div>

        <div class="w-px h-96 line-loading-gradient mx-3 md:flex hidden"></div>
        <LoginForm />
      </div>
    </template>

    <template #bottom>
      <div class="absolute bg-color-load-header-blue w-full md:h-48 h-1/5 bottom-0 up-stroke-green-2">
        <div class="flex justify-center items-center h-full">
          <div class="app-container">
            <div class="flex justify-between items-center md:gap-8 gap-8">
              <div class="relative inline-block text-left text-white md:text-xl text-sm">
                <div @click="toggleDropdown" class="flex items-center md:gap-3 gap-2 cursor-pointer">
                  <img :src="flagSrc" :alt="$t('alt.currLang') + ' ' + localeNames[localeStore.currentLocale]" class="md:w-9 md:h-5 w-22 h-22 object-cover" />
                  <button class="inline-flex justify-center items-center w-full focus:outline-none font-franklin">
                    {{ localeNames[localeStore.currentLocale] }}
                    <svg class="mr-1 md:ml-2 md:h-5 md:w-5 h-3 w-3 ml-px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                      <path
                        fill-rule="evenodd"
                        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                        clip-rule="evenodd"
                      />
                    </svg>
                  </button>
                </div>

                <div v-if="dropdownOpen" class="absolute left-0 mt-2">
                  <div role="menu" aria-orientation="vertical" aria-labelledby="options-menu" class="bg-color-load-header-blue rounded shadow-lg">
                    <a
                      v-for="locale in filteredLocales"
                      :key="locale"
                      @click="changeLocale(locale)"
                      class="flex items-center md:gap-3 gap-2 md:py-2 py-1.5 cursor-pointer hover:bg-opacity-80 font-franklin"
                    >
                      <img :src="getAssetPath(`/img/icons/langs/flag-${locale}.webp`)" :alt="localeNames[locale]" class="md:w-8 md:h-4.5 w-22 h-22 object-cover" />
                      <span class="md:text-xl text-sm">{{ localeNames[locale] }}</span>
                    </a>
                  </div>
                </div>
              </div>
              <div class="flex text-white md:text-sm text-xs font-bold md:mr-10 md:w-2/6">
                <h4>
                  {{ $t('message.explainer') }}
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </ContentCenter>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useLocaleStore } from '@/stores/localeStore'
import { getAssetPath } from '@/utils/assetPath'
import LoginForm from '@/components/Loading/LoginForm.vue'
import ContentCenter from '@/layouts/ContentCenter.vue'

const { locale } = useI18n()
const localeStore = useLocaleStore()
const dropdownOpen = ref(false)
const locales = ['en', 'he']
const localeNames = {
  en: 'English',
  he: 'עברית'
}

// Ensure i18n locale is synced with localeStore on mount
onMounted(() => {
  locale.value = localeStore.currentLocale
})

const flagSrc = computed(() => {
  return getAssetPath(`/img/icons/langs/flag-${localeStore.currentLocale}.webp`)
})

const toggleDropdown = () => {
  dropdownOpen.value = !dropdownOpen.value
}

const changeLocale = (newLocale) => {
  locale.value = newLocale
  localeStore.setLocale(newLocale)
  dropdownOpen.value = false
}

const filteredLocales = computed(() => {
  return locales.filter((l) => l !== localeStore.currentLocale)
})
</script>
